import { ResponsesData } from 'features/CustomFieldsResponses/types';
import { isEmbeddedInIframe } from 'utils/utils';

/**
 * Hands an attendee row's refund to the Punchup host, which loads the row's order (the fees, taxes and
 * add-ons a row doesn't carry) into its own refund modal and posts `refund-ticket-success` once it's done.
 * Returns false when there is no host to ask (standalone tixologi) or the request has an id the host would
 * drop (it takes only positive whole numbers), so the caller opens its own refund modal instead.
 */
const isId = (value: unknown) => typeof value === 'number' && Number.isInteger(value) && value > 0;

export const delegateRefundToHost = (row: ResponsesData, routeEventId?: string): boolean => {
	/* On a festival-wide attendee list a row can belong to another show than the page's, so the row's own
	 * show comes first; the route is the fallback for rows that do not carry it. */
	const eventId = row.event_id ?? Number(routeEventId);
	const payload = { userId: row.user_id, orderId: row.order_id, ticketId: row.ticket_id, eventId };
	if (!isEmbeddedInIframe() || !Object.values(payload).every(isId)) return false;

	window.parent.postMessage({ action: 'open-refund-ticket', payload }, '*');
	return true;
};
